import styled from '@emotion/styled';

import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const Header = styled.div`
	display: grid;
	grid-template-columns: max-content 3rem;
	align-items: center;
	gap: 0.5rem;
`;

export const StyledDataCard = styled(Card)`
	cursor: pointer;
	border: 1px solid var(--border-color);
	padding: var(--padding-4);
	padding-bottom: var(--padding-2);
	background-color: var(--white);
	border-radius: var(--small-border-radius);
	display: grid;
	align-items: center;
	transition: transform 0.2s ease;
	&:hover {
		transform: scale(1.025);
	}
`;

export const TextWrapper = styled.div`
	min-height: 7rem;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const GridContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(24rem, 1fr));
	gap: 1rem;

	@media ${Breakpoints.xldesktop} {
		grid-template-columns: repeat(4, 1fr);
	}

	@media ${Breakpoints.mobileLandscape} {
		grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));
	}
`;

export const EmptyContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	width: 100%;
	padding: 4.5rem 0;
	text-align: center;
`;

export const ViewLink = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;
	justify-self: end;
	background: transparent;
	border-color: transparent;
	color: var(--blue);

	body[dir='rtl'] & {
		.icon {
			transform: scale(-1, 1);
		}
	}
`;
